<template>
    <div class="doc_sb_edit p-3">
        <div class="template p-3">
            <organization_select
                @on_organization_set="set_org_id"
                :active_id="parseInt(cur_tov_id)">
            </organization_select>
        </div>
        
        <div class="template p-3">
            <div class="form-group">
                <label class="form-label" for="payment_online">
                    Виберiть з випадаючого списку стан*
                </label>
                <div>
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="doc_rating"
                        button-variant="outline-primary"
                        :options="rating_variants"
                        name="radios-btn-default"
                        buttons
                    ></b-form-radio-group>
                </div>
            </div>
        </div>
        
        <div class="template p-3">
            <label class="form-label" for="payment_online">
                Введiть коментар
            </label>
            
            <div class="select_step">
                <b-textarea v-model="doc_comment" :rows="10"></b-textarea>
            </div>
        </div>
    </div>
</template>


<script>
import Organization_select from "../../../../shared/select/organization_select.vue";

export default {
    name: "doc_general",
    components: {Organization_select},
    props : {
        doc : {
            type : Object,
        }
    },
    
    methods : {
        set_org_id(org_id) {
            this.$emit('doc_change',{
                'type' : 'tov_id',
                'val'  : org_id
            });
        }
    },
    
    computed : {
        cur_tov_id () {
            if(this.doc.hasOwnProperty("tov_id")) {
                return this.doc.tov_id;
            }
            return null;
        },
        
        doc_rating: {
            get() {
                if (this.doc.hasOwnProperty("rating_id")) {
                    return this.doc.rating_id;
                }
                
                return 0;
            },
            set(val) {
                this.$emit('doc_change',{
                    'type' : 'rating_id',
                    'val'  : val
                });
            }
        },
        
        doc_comment : {
            get() {
                if (this.doc.hasOwnProperty("coment")) {
                    return this.doc.coment;
                }
                
                return "";
            },
            set(val) {
                this.$emit('doc_change',{
                    'type' : 'coment',
                    'val'  : val
                });
            }
        },
        
        
        rating_variants() {
            return [
                { text: 'Добрий', value: 1 },
                { text: 'Задов.', value: 2 },
                { text: 'Незадов.', value: 3 },
            ]
        },
        
    }
}
</script>


<style scoped>

</style>